<template>
  <div>
    <v-card-title>
      <h2>Form Templates</h2>
      <v-spacer/>
      <v-btn
        dark
        color="blue"
        round
        @click="addTemplate()">
        <v-icon dark>add</v-icon>
        New Template
      </v-btn>
    </v-card-title>
    <br />
    <v-layout
      row wrap
    >
      <v-flex
        sm12
        md3
        style="padding:0 5px 0 5px;"
      >
        <v-card>
          <v-toolbar
            class="primary-color"
            dense
            flat
            dark
          >
            Search &amp; Filtering
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="searchText"
              append-icon="search"
              label="Search Text"
              single-line
              hide-details
              v-on:keyup.enter="search"
              @blur="search"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="searchText='';search()"
            >
              Clear
            </v-btn>
            <v-btn
              color="primary"
              @click="search"
            >
              Search
            </v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        sm12
        md9
      >
        <v-card>
          <v-data-table
            :items="templates"
            :pagination.sync="pagination"
            :total-items="totalTemplates"
            :rows-per-page-items="paginationStrings"
            :headers="headers"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr>
                <td colspan="4">
                  <div style="text-align:center;padding:25px;">
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No Results</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td>
                  <router-link :to="{ name: 'FormTemplate', params: { id: props.item.id } }">
                    <b>{{ props.item.name }}</b>
                  </router-link>
                </td>
                <td>
                  <span>{{ convertToLocal(props.item.created_at) }}<br />
                    <small style="color:black;">{{props.item.created_by_name}}</small>
                  </span>
                </td>
                <td>
                  <span>{{ convertToLocal(props.item.updated_at) }}<br />
                    <small style="color:black;">{{props.item.updated_by_name}}</small>
                  </span>
                </td>
                <td class="justify-center layout px-0">
                  <v-icon
                    small
                    class="mr-2"
                    @click="$router.push({ name: 'FormTemplate', params: { id: props.item.id } })"
                  >
                    edit
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'

export default {
  name: 'FormTemplateList',
  mixins: [
    pagination
  ],
  data () {
    return {
      templates: [],
      pagination: {
        page: this.$route.query.page || 1,
        descending: this.$route.query.descending || false,
        rowsPerPage: this.$route.query.rowsPerPage || 10,
        sortBy: this.$route.query.sortBy || null
      },
      defaultPagination: {
        page: 1,
        descending: false,
        rowsPerPage: 10,
        sortBy: null
      },
      searchText: this.$route.query.search || '',
      loading: true,
      paginationStrings: [
        10, 25, 50
      ],
      headers: [
        { text: 'Template Name', value: 'name' },
        { text: 'Created', value: 'created_at' },
        { text: 'Last Edit', value: 'updated_at' },
        { text: 'Actions', align: 'center', sortable: false }
      ]
    }
  },
  created () {
    this.documentTitle('Form Templates')
  },
  computed: {
    totalTemplates () {
      return this.pagination.totalItems
    }
  },
  methods: {
    fetch () {
      this.loading = true
      api.formtemplate.formtemplate.list({
        search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, pageNum: this.pagination.page, count: this.pagination.rowsPerPage
      })
        .then(data => {
          this.templates = data.results
          this.pagination.totalItems = data.count
          this.pagination.page = data.page_number
          this.loading = false
          this.componentCreated = true
        })
    },
    addTemplate () {
      this.$router.push({ name: 'FormTemplate' })
    }
  }
}
</script>

<style>

table {
  table-layout: fixed;
}

.search-bar {
  margin-top: 1em;
}

table {
  margin-top: 1em;
}

</style>
